import { render, staticRenderFns } from "./DynamicAttributeCreate.vue?vue&type=template&id=326b83c9&"
import script from "./DynamicAttributeCreate.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports